<nav class="navbar navbar-expand-lg navbar-light nav-border">
    <div class="d-flex flex-column cont-width">
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button> -->

        <a class="navbar-brand brand-logo" href="#">
            <img class="brand-image" src="https://specscart.co.uk/skin/frontend/rwd/default/img/specscart.png"
                alt="Specscart">
        </a>

        <div class="top-nav">
            <span class="float-start collapse navbar-collapse">
                <a href="">Free Returns</a> | <a href="">Try at Home</a> | <a href="">24 Hr Dispatch*</a>
            </span>
            <span class="float-end collapse navbar-collapse">
                <a href="">+441613125767</a> | <a href="">Help</a> | <a href="">Login</a> | <a href="">Register</a>
            </span>
        </div>

        <div class="d-flex justify-content-end">
            <span class="float-start collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="#">Glasses</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">Sunglasses</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">Eye-Test</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">Blogs</a>
                    </li>
                </ul>
            </span>
            <span class="float-end user-actions align-self-center">
                <a href=""><img src="../../assets/Group2964.png" alt=""></a>
                <a href=""><img src="../../assets/Group2966.png" alt=""></a>
                <a href=""><img src="../../assets/Group2965.png" alt=""></a>
                <a href=""><img src="../../assets/Group2967.png" alt=""></a>
                <a href=""><img src="../../assets/Cart.png" alt=""></a>
            </span>
        </div>

    </div>
</nav>